import React, { useEffect, useState } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import firebase from 'firebase'
import { useSelector } from 'react-redux';
import { fetchChatUser, loadMessages, loadRecentChats, sendMediaMessage, sendMessage, refreshChannel, searchMessage } from '../../api/chat';
import { ChatHeader, ChatInput, MessageBox, MessageBoxRemote, MessageHeader, Usercard } from '../../components/chat'
import { EmptyScreen } from '../../components/common/EmptyScreen';
import { Input } from '../../components/common/Input'
import './newchat.sass'
import { useRef } from 'react';
import { useHistory, useLocation } from 'react-router';
import { getUserByID } from '../../api/auth'
import { ChatShimmer } from '../../components/common/Shimmer';



export default function NewChat() {

    const chatEnd = useRef()
    const locaton = useLocation()

    const history = useHistory()

    const [loadingRecentChat, setLoadingRecentChat] = useState(true);
    let isDark = useSelector(state => state.isDark);
    const [recentChats, setRecentChats] = useState([])
    let userID = useSelector(state => state.userState.id);
    const [isReady, setIsReady] = useState(false);
    const [selectedChatDoc, setSelectedChatDoc] = useState(null);
    const [isDesktopModalVisible, setIsDesktopModalVisible] = useState(false);
    const [uploadState, setUploadState] = useState("UPLOAD")
    const [chatList, setChatList] = useState([]);
    const [ghostText, setGhostText] = useState(true);
    const [locationKeys, setLocationKeys] = useState([])
    const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);
    const [queryType, setQueryType] = useState(0);
    const [queryString, setQueryString] = useState("")
    const [matchedMsg, setMatchedMsg] = useState([])
    const [msgSearchComplete, setMsgSearchComplete] = useState(true);


    const initalizeChat = async (e) => {
        const res = await refreshChannel(e.channelID)
        if (!res) {
            return
        }
        const userData = await getUserByID(e.remoteID)
        const lastMsg = await firebase.firestore().collection('chats')
            .doc(e.channelID).collection('messages')
            .orderBy('timestamp', 'desc').limit(1).get();
        let payload = {}
        if (lastMsg.docs.length > 0) {
            payload = {
                user: userData,
                id: e.channelID,
                notification: res.notification,
                read: res.read,
                msg: lastMsg
            }
        }
        else {
            payload = {
                user: userData,
                id: e.channelID,
                notification: res.notification,
                read: res.read,
                msg: ''
            }
        }
        openMessageBox(payload)
    }

    useState(() => {
        if (locaton.state) {
            console.log(" this motherfucker is trying to initialize the chat :", locaton);
            try {
                initalizeChat(locaton.state)
            } catch (e) {
            }
        }
    }, [])


    // this useEffect will trigger initially for desktop conditions
    useEffect(() => {
        if (!selectedChatDoc) {
            if (document.body.clientWidth > 750) {
                document.getElementById('chatRightCol').style.display = 'none';
            } else if (document.body.clientWidth < 750 && document.body.clientWidth < 580) {
                document.getElementById('chatRightCol').style.display = 'none';
                document.getElementById('mobileNav').style.display = "flex"

            }
        } else {
            if (document.body.clientWidth < 750 && document.body.clientWidth > 580) {
                document.getElementById('chatRightCol').style.display = 'none';
            }
        }
    }, [])


    // useEffect to watch for width height change
    const updateWindowWidth = () => {
        // setBodyHeight(document.body.clientHeight);
        setBodyWidth(document.body.clientWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', updateWindowWidth);
        console.log("this useeffect is runnig");
        if (document.getElementById('chatRightCol') && document.getElementById('chatLeftCol')) {
            console.log("we have the right and left col");
            if (bodyWidth <= 580) {
                console.log("this is 580");
                if (document.getElementById('chatRightCol').style.display == 'none') {
                    document.getElementById('mainWrapper').style.cssText = "padding: 70px 10px !important"
                    document.getElementById('chatRightCol').style.display = 'none';
                    document.getElementById('chatLeftCol').style.display = 'flex';
                    document.getElementById('mobileWrapper').style.display = "flex"
                } else {
                    document.getElementById('chatRightCol').style.display = 'flex';
                    document.getElementById('chatLeftCol').style.display = 'none';
                    document.getElementById('mobileWrapper').style.display = "none";
                    document.getElementById('mobileWrapper').style.padding = "0";
                    document.getElementById('mainWrapper').style.cssText = "padding:0px !important"
                }
                // setSelectedChatDoc(null)
            } else if (bodyWidth < 750 && bodyWidth > 580) {
                document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"
                console.log("this is 750");
                if (document.getElementById('chatRightCol').style.display == 'none') {
                    document.getElementById('chatRightCol').style.display = 'none';
                    document.getElementById('chatLeftCol').style.display = 'flex';
                    document.getElementById('mobileWrapper').style.display = "flex"
                    console.log("display is none");
                } else {
                    if(selectedChatDoc){
                        document.getElementById('chatRightCol').style.display = 'flex';
                        document.getElementById('chatLeftCol').style.display = 'none';
                        document.getElementById('mobileWrapper').style.display = "flex"
                        console.log("display is there");
                    } else {
                        document.getElementById('chatRightCol').style.display = 'none';
                        document.getElementById('chatLeftCol').style.display = 'flex';
                        document.getElementById('mobileWrapper').style.display = "flex"   
                    }
                }
                // setSelectedChatDoc(null)
            } else {
                console.log("this is 1000");
                document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"
                if (document.getElementById('chatRightCol')) {
                    if (document.getElementById('chatRightCol').style.display == 'none') {
                        document.getElementById('chatRightCol').style.display = 'none';
                    } else {
                        document.getElementById('chatRightCol').style.display = 'flex';
                    }
                }
                document.getElementById('chatLeftCol').style.display = 'flex';
                // setSelectedChatDoc(null)
            }
        }
        return () => {
            if (document.body.clientWidth < 580) {
                console.log("setting main wrapper padding 70 10");
                document.getElementById('mainWrapper').style.cssText = "padding: 70px 10px 70px 10px !important"
            } else if (document.body.clientWidth > 580) {
                console.log("setting main wrapper padding 70 10");
                document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"
            }
            window.removeEventListener('resize', updateWindowWidth);
        }
    }, [bodyWidth]);



    //  use effect to load all the recent chats
    useEffect(() => {
        let tempRecentChats = []
        if (userID != null && userID != undefined && userID) {
            loadRecentChats(userID, async observer => {
                setTimeout(async () => {
                    tempRecentChats = [];
                    for (var i = 0; i < observer.docs.length; i++) {
                        var userData = null;
                        var lastMsg = null;
                        var remoteUser = Object.entries(observer.docs[i].data().participants).filter(el => el[0] != userID)
                        userData = await fetchChatUser(remoteUser[0][0])
                        lastMsg = await firebase.firestore().collection('chats')
                            .doc(observer.docs[i].id).collection('messages')
                            .orderBy('timestamp', 'desc').limit(1).get();

                        var recentChatData = null;
                        if (lastMsg.docs[0] == undefined) {
                            recentChatData = {
                                user: userData,
                                msg: "",
                                id: observer.docs[i].id,
                                notification: observer.docs[i].data().notification,
                                read: observer.docs[i].data().read
                            }
                            setIsReady(true);
                        } else {
                            recentChatData = {
                                user: userData,
                                msg: lastMsg.docs[0].data(),
                                id: observer.docs[i].id,
                                notification: observer.docs[i].data().notification,
                                read: observer.docs[i].data().read
                            }
                            setIsReady(true);
                        }
                        tempRecentChats.push(recentChatData);

                    };
                    const fTemp = tempRecentChats.filter((v, i, a) => a.findIndex(t => (t.user.id === v.user.id)) === i)
                    const sortedFTemp = fTemp.sort((x, y) => y.msg.timestamp - x.msg.timestamp)
                    // console.log(sortedFTemp[sortedFTemp.length - 1], selectedChatDoc)

                    setRecentChats(sortedFTemp);
                    setLoadingRecentChat(false);
                })
            }, 0)
        }

    }, [userID])
    useEffect(() => {
        let tempChatList = []
        if (selectedChatDoc != null && selectedChatDoc != undefined && selectedChatDoc) {
            loadMessages(selectedChatDoc, (observer) => {
                tempChatList = []
                for (var i = 0; i < observer.docs.length; i++) {
                    tempChatList.push(observer.docs[i].data())
                }
                setChatList(tempChatList);

            })
        }
    }, [selectedChatDoc])

    useEffect(() => {
        chatEnd.current.scrollIntoView({ behaviour: 'smooth' })
    }, [chatList])


    // this use effect is being used for rendering navbar on browser abck button
    useEffect(() => {
        history.listen(location => {
            if (history.action === 'POP') {
                if (locationKeys[1] === location.key) {
                    setLocationKeys(([_, ...keys]) => keys)
                    document.getElementById('desktopWrapper').style.display = "flex";
                    document.getElementById('mobileWrapper').style.display = "flex"

                } else {
                    setLocationKeys((keys) => [location.key, ...keys])
                    document.getElementById('desktopWrapper').style.display = "flex";
                    document.getElementById('mobileWrapper').style.display = "flex"
                }
            }
        })
    }, [locationKeys])

    // a function to open chats
    const openMessageBox = (data) => {
        if (data.remoteUser) {
            console.log(data.remoteUser)
            data.user = data.remoteUser
        }
        if (document.body.clientWidth > 750) {
            console.log("body is frater then 750px")
            if (document.getElementById('chatRightCol').style.display == "flex") {
                console.log("display is flex")
                if (selectedChatDoc == data) {
                    console.log('hidnig the right side')
                    document.getElementById('chatRightCol').style.display = "none"
                    // setSelectedChatDoc(null)
                    setGhostText(true)
                } else {
                    setSelectedChatDoc(data)
                    setGhostText(false)
                }

            } else {
                document.getElementById('chatRightCol').style.display = "flex"
                setSelectedChatDoc(data)
                setGhostText(false)
            }
        } else if (document.body.clientWidth < 750 && document.body.clientWidth > 580) {
            document.getElementById('chatRightCol').style.display = 'flex';
            document.getElementById('chatLeftCol').style.display = 'none';
            setSelectedChatDoc(data)
            setGhostText(false)
        } else if (document.body.clientWidth < 580) {
            document.getElementById('chatRightCol').style.display = 'flex';
            document.getElementById('chatLeftCol').style.display = 'none';
            document.getElementById('mobileWrapper').style.display = "none";
            document.getElementById('mobileWrapper').style.padding = "0";
            document.getElementById('mainWrapper').style.cssText = "padding:0px !important"
            setSelectedChatDoc(data)
            setGhostText(false)
        }
    }

    //  functions related to message input box

    const handleDesktopModalToggle = (e) => {
        setIsDesktopModalVisible(e)
    }

    const handleMessageSend = (e) => {
        sendMessage(selectedChatDoc.id, e, userID)
    }

    const handleMsgMediaSend = async (e, price, isPaid) => {
        setUploadState("UPLOADING...")
        const blob = URL.createObjectURL(e)
        const type = e.type;
        await sendMediaMessage(selectedChatDoc.id, blob, userID, type, price, isPaid)
        console.log(blob, type)
        setIsDesktopModalVisible(false)
        setUploadState("DONE")
    }

    const handleEmitQueryType = (e) => {
        setQueryType(e);
    }




    const handleMsgSearch = async (e) => {
        setQueryString(e);
        if (e.length == 0) {
            setMatchedMsg([])
            return;
        }
        else {
            setMsgSearchComplete(false);
            const res = await searchMessage(e, userID)
            setMatchedMsg(res);
            setMsgSearchComplete(true)
        }
    }


    const handleMessageSearchInput = (e) => {
        if (e.keyCode == 13 || e.which == 13) {
            handleMsgSearch(queryString)
        }
    }

    useEffect(() => {
        if (queryString.length == 0) {
            setMatchedMsg([])
        }
    }, [queryString])


    return (
        <div className="chat-wrapper">
            <div className="chat-left-column" id="chatLeftCol">
                <div className='left-column-header'>
                    <MessageHeader emitQueryType={handleEmitQueryType} />
                </div>
                <div className="left-column-searchbar">
                    {queryType != 0 && <Input handleIconClick={e => handleMsgSearch(queryString)} handleInputChange={e => setQueryString(e.target.value)} handleOnKeyPress={handleMessageSearchInput} value={queryString} icon="search_a.svg" placeholder={queryType == 1 ? 'Search Messages' : 'Search User'} />}
                </div>
                <div className="recent-chats-wrapper">
                    {
                        matchedMsg.length == 0 ? loadingRecentChat ?
                            <div >
                                <ChatShimmer />
                                <ChatShimmer />
                                <ChatShimmer />
                                <ChatShimmer />
                                <ChatShimmer />
                            </div> :
                            (recentChats && recentChats.length === 0) ?
                                <EmptyScreen heading='No Message' logo='msg_a' btntext='New Message' description='Your inbox is empty. You can search on your list and start your first conversation.' /> :
                                recentChats.map((data, index) => <Usercard key={index} data={data} click={(data) => { openMessageBox(data) }} />)
                            : <div>
                                {matchedMsg.map((data, index) => <Usercard key={index} data={data} click={(data) => { openMessageBox(data) }} />)}
                            </div>}
                </div>
            </div>

            <div className="chat-right-column" id="chatRightCol">
                <div className="chatbox-header">
                    {selectedChatDoc && <ChatHeader data={selectedChatDoc} />}
                </div>
                <div className="chat-area">
                    {
                        (!isReady) ?
                            <div className='loading-text'></div> :
                            chatList.map(function (data, index) { return data.uid == userID ? <MessageBox key={index} data={data} /> : <MessageBoxRemote key={index} data={data} user={selectedChatDoc} /> })
                    }
                    <div ref={chatEnd}></div>
                </div>
                <div className="chat-typing-area">
                    <ChatInput handleDesktopModalToggle={handleDesktopModalToggle} isDesktopModalVisible={isDesktopModalVisible} uploadState={uploadState} handleSend={handleMessageSend} handleMediaSend={handleMsgMediaSend} />
                </div>
            </div>
            {
                (ghostText && document.body.clientWidth > 750) ?
                    <EmptyScreen heading='No Message' logo='msg_a' btntext='New Message' description='Your inbox is empty. You can search on your list and start your first conversation.' /> :
                    ""
            }
        </div>
    )
}
